// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4172":"017e440e","5643":"263ac86d","9782":"d9fc6deb"}[chunkId] + ".chunk.css";
};